// DO NOT EDIT, GENERATED BY "yarn sheets"

import type { ShellBackDesignRow } from '../typings';

const data = [
  {
    "id": "leather",
    "name": "Leather",
    "description": "full leather back",
    "subsets": {
      "leatherId": {
        "pcfp": true
      }
    }
  },
  {
    "id": "pro",
    "name": "Pro",
    "description": "half mesh and half leather",
    "legacyName": "Pro Mesh",
    "props": {
      "skuSuffix": "M"
    },
    "subsets": {
      "leatherId": {
        "pcfp": true
      }
    }
  },
  {
    "id": "deco",
    "name": "Deco",
    "description": "full mesh back with leather accents",
    "legacyName": "Deco Mesh",
    "props": {
      "skuSuffix": "DM"
    },
    "subsets": {
      "leatherId": {
        "pcfp": true
      }
    }
  }
] as const;

type Primitive = string | number | boolean | null | undefined;
type Immutable<T> = T extends Primitive
  ? T
  : { readonly [K in keyof T]: Immutable<T[K]> };

type Combine<T extends U, U> = T extends Readonly<Primitive | Primitive[]>
  ? T
  : T extends ReadonlyArray<infer I>
  ? Readonly<Combine<I, Extract<U, Readonly<any[]>>[number]>[]>
  : U extends Readonly<Primitive | any[]>
  ? never
  : string extends keyof U
  ? { [K in keyof T & string]: Combine<T[K], U[K]> }
  : number extends keyof U
  ? { [K in keyof T & number]: Combine<T[K], U[K]> }
  : symbol extends keyof U
  ? { [K in keyof T & symbol]: Combine<T[K], U[K]> }
  : { [K in keyof U]: Combine<T[K], U[K]> };

const typed: Combine<typeof data, Immutable<ShellBackDesignRow[]>> = data;

export type ShellBackDesign = typeof typed[number];

export const SHELL_BACK_DESIGN_INDEX_KEY = "id";
export type ShellBackDesignIndexKey = "id";
export type ShellBackDesignId = ShellBackDesign["id"];

let i = 0;
export const SHELL_BACK_DESIGN_DICT = {
  "leather": typed[i++],
  "pro": typed[i++],
  "deco": typed[i++]
} as const;

export { typed as SHELL_BACK_DESIGNS };
